
(function () {
    // console.log('call form request form');

    // グローバル空間にオブジェクトを生成 (既にある場合はそのまま)
    window.ssjk2021 = window.ssjk2021 || {};

    function CreateRequestFormApp(js_params){
        const app_vue_id = js_params.app_vue_id;

        ////
        const app_vue_css_tgt = "#" + app_vue_id;

        // var data = js_params.attributes;
        // console.log(data);

        var app = new Vue({
            el: app_vue_css_tgt,
            data: {
                attributes: js_params.attributes,
            },
            computed: {
                isAdmissionExist: function () {
                    // console.log(this.attributes.admission_exist);

                    return (this.attributes.admission_exist == 1);
                },
                YenRequired: function () {
                    // console.log("YenRequired");

                    if (this.isAdmissionExist) {
                        return true;
                    }
                    return false;
                },
                OLCCondRequired: function (){
                    if(this.attributes.outside_line_capable == 3){
                        return true;
                    }
                    return false;
                }
            },
            methods: {
            },
            mounted: function (){
                // console.log('mounted');
                // Vue.js で yubinbango.js の元々の keyup イベントを上書き消してしまっているように見えたため、再度実行させる。
                // yubinbango.js をロード済みなこと前提。
                var yb = new YubinBango.MicroformatDom;
                // console.log(yb);
            }
        });
        // console.log(app);
        var vueObj = app;
    }

    // ここが有効になればグローバルに使えるようになる。
    window.ssjk2021.CreateRequestFormApp = CreateRequestFormApp;
})();
